import { type GuardResult, guardStandaloneImageGenSelection } from '@glyphic/shared-core'
/** 出图前校验：模型与尺寸须由用户显式选择，不做服务端默认兜底。 */
export function validateImageGenParams(
  platformId: string,
  modelId: string,
  apiSize: string,
  dimensionMode?: 'size' | 'aspect_ratio',
): GuardResult {
  return guardStandaloneImageGenSelection({ platformId, modelId, apiSize, dimensionMode })
}

/** @deprecated 使用 GuardResult；保留别名便于旧代码迁移 */
export type ImageGenParamsValidation = GuardResult
